import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	commentHeaderPrefix: {
		id: 'search-page.embedded-comments.comment-header-prefix',
		defaultMessage: 'Re: {label}',
		description:
			'Prefix shown before the matched anchor / context label in an embedded comment header (e.g. "Re: search results"). Mirrors the email-style "Re:" reply convention so the row visually echoes the reply icon to its left.',
	},
});
